// public/js/features/devices/modals/assign-device-modal.js
import { loadAssets } from '../../assets/api.js';
import { deviceTypeLabel } from '../device-type.js';
import { tName } from '../../../modules/demo-mode.js';

export function createAssignDeviceModal() {
  const body = document.body;

  // === CREATE MODAL HTML (if not present yet) ===
  if (!document.getElementById('assignDeviceModal')) {
    const modal = document.createElement('div');
    modal.className = 'modal fade';
    modal.id = 'assignDeviceModal';
    modal.tabIndex = -1;

    modal.innerHTML = `
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-dark text-white border-secondary">
          <div class="modal-header border-secondary">
            <h5 class="modal-title">
              <i class="fa-solid fa-link me-2"></i> Assign device to an asset
            </h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
          </div>

          <div class="modal-body">
            <div id="assign-device-info" class="mb-3 p-2 bg-secondary bg-opacity-25 rounded"></div>

            <div class="mb-3">
              <label class="form-label fw-bold">Select asset</label>
              <select id="assign-asset-select" class="form-select bg-dark text-white"></select>
            </div>
          </div>

          <div class="modal-footer border-secondary">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
            <button type="button" id="btn-confirm-assign" class="btn btn-primary">
              <i class="fa-solid fa-link me-2"></i> Assign
            </button>
          </div>
        </div>
      </div>
    `;

    body.appendChild(modal);
  }

  const modalEl = document.getElementById('assignDeviceModal');
  let $assetSelect = null;

  window.openAssignDeviceModal = async (device, refreshCallback) => {
    const modal = new bootstrap.Modal(modalEl);
    modal.show();

    document.getElementById('assign-device-info').innerHTML = `
      <strong>${device.deviceId}</strong> (${deviceTypeLabel(device)})<br>
      <small class="text-muted">Tenant: ${tName(device.tenantName || device.tenantId)}</small>
      ${device.lastSeen ? `<br><small>Last contact: ${new Date(device.lastSeen).toLocaleString(navigator.language)}</small>` : ''}
    `;

    try {
      const assets = await loadAssets();
      const select = document.getElementById('assign-asset-select');
      select.innerHTML = `<option value="">-- Select asset --</option>` +
        assets.map(a => `<option value="${a.assetId}">${a.name || a.assetId} (${a.type || 'other'})</option>`).join('');

      if ($assetSelect?.data('select2')) $assetSelect.select2('destroy');

      $assetSelect = $(select).select2({
        placeholder: 'Search asset...',
        allowClear: true,
        width: '100%',
        dropdownParent: modalEl
      });
    } catch (e) {
      console.error(e);
      window.showToast('Failed to load assets', 'danger');
    }

    // Replace the confirm button (duplicate-safe)
    const confirmBtn = document.getElementById('btn-confirm-assign');
    const freshBtn = confirmBtn.cloneNode(true);
    confirmBtn.replaceWith(freshBtn);

    freshBtn.onclick = async () => {
      const assetId = $assetSelect.val();
      if (!assetId) return window.showToast('Please select an asset', 'warning');

      freshBtn.disabled = true;
      freshBtn.innerHTML = `<span class="spinner-border spinner-border-sm me-2"></span> Assigning...`;

      try {
        await window.authenticatedFetch(`api/v1/devices/${encodeURIComponent(device.deviceId)}/assign`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ assetId })
        });

        window.showToast(`✅ Device ${device.deviceId} assigned to asset ${assetId}`, 'success');
        modal.hide();

        if (refreshCallback) await refreshCallback();
        if (window.refreshDevices) await window.refreshDevices();
        // Optional: trigger a map refresh
        if (window.dispatchEvent) window.dispatchEvent(new CustomEvent('assets-updated'));
      } catch (err) {
        console.error(err);
        window.showToast(err.message || 'Assignment failed', 'danger');
      } finally {
        freshBtn.disabled = false;
        freshBtn.innerHTML = 'Assign';
      }
    };
  };
}